import { toast } from "react-toastify";
import { PageAPI } from "../constants/apiRoutes";
import { pageActions } from "../reducers/page";
import apiService from "../utils/configAxios";
import { handleError } from "../utils/handleError";

export const fetchUpdatePage = (data, id) => {
  return (dispatch) => {
    dispatch(pageActions.actionStart());
    return apiService
      .put(PageAPI.update(id), data)
      .then((response) => {
        dispatch(pageActions.actionSuccess("update"));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchPageList = () => {
  return (dispatch) => {
    return apiService
      .get(PageAPI.get())
      .then((response) => {
        dispatch(pageActions.fetchPageList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchPageById = (id = 0) => {
  return (dispatch) => {
    return apiService
      .get(PageAPI.getById(id))
      .then((response) => {
        dispatch(pageActions.fetchPageDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};
